import React, { useState } from "react";
import "./dropdownwithbutton.css";

export default function DropdownWithButton({
  options,
  placeholder,
  onClick,
  formData,
  setFormData,
  createAttributes,
  title,
  setModuleName,
  handleFormDataUpdate,
}) {
  const [selectedValue, setSelectedValue] = useState("");
  const loanModules = [
    "Joint Obligations",
    "Individual Obligations",
    "Pre Marriage Debt",
  ];
  console.log("All dropdown options from DB:", options);
  const isLoanModule =
    title && loanModules.some((module) => title.includes(module));
  const handleSelectChange = (e) => {
    const selected = e.target.value;
    setSelectedValue(selected);
    handleDropdownClick();

    const selectedOption = options.find((opt) =>
      isLoanModule
        ? opt["Nickname of Liabilities"] === selected
        : opt.value == selected
    );

    if (selectedOption) {
      setFormData((prev) => ({
        ...prev,
        ...selectedOption,
         ...(isLoanModule && {
      "Liability": selectedOption["Nickname of Liabilities"],
      "Balance": selectedOption["Loan Balance"] || selectedOption["Initial Loan Amount"] || 0,
      "Monthly Payment": selectedOption["Monthly Payment"] || 0,
    }),
      }));

      if (handleFormDataUpdate) {
        handleFormDataUpdate(selectedOption);
      }

      console.log("Selected object from DB:", selectedOption);
    } else {
      console.log("No match found for selected value:", selected);
    }
  };

  const handleButtonClick = () => {
    createAttributes();

    console.log(
      "Apply button clicked with value and handleformdataupdate called:",
      selectedValue
    );

    if (onClick) {
      onClick();
    }
  };

  const handleDropdownClick = () => {
    console.log("Module Name Set:", title);
    if (title) {
      setModuleName(title);
    }
  };
  return (
    <div className="dropdown-main-container">
      <div className="dropdown-wrapper">
        <select
          className="dropdown-select"
          id="dropdown-select"
          name="options"
          onChange={handleSelectChange}
          value={selectedValue}
        >
          <option value="" disabled>
            {placeholder || "Select"}
          </option>
          {options &&
            options.map((option) => (
              <option key={option.value} value={option.value}>
                {isLoanModule
                  ? option["Nickname of Liabilities"]
                  : option.label}
              </option>
            ))}
        </select>
      </div>
      <div className="dropdown-add-button-container">
        <button className="dropdown-add-button" onClick={handleButtonClick}>
          Apply
        </button>
      </div>
    </div>
  );
}
